import React, { useContext } from "react";
import localization from "assets/localization/localization";
import { Link } from "react-router-dom";
import { BaseUrl } from "contexts/baseUrl/baseUrl";

const Notfound = () => {
  const { baseUrl } = useContext(BaseUrl);
  return (
    <div className="d-flex flex-column w-100 justify-content-center align-items-center">
      <h3 className="mb-0 mt-3">{localization.AccessDenied}</h3>
      <span>{localization.notAccess}</span>
      <Link className="btn btn-primary" to={baseUrl}>
        {localization.goBack}
      </Link>
    </div>
  );
};

export default Notfound;
